<template>
  <path fill-rule="nonzero" d="M3.422 9.08l.97.92.972-.92L13 1.84 11.058 0 4.393 6.344l-2.45-2.35L0 5.837z"/>
</template>

<script>
export default {
    name: 'CheckV2Icon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 13 10');
    }
};
</script>
